/*
 * Direct RudderStack event poster for first-party custom events.
 *
 * Why this exists:
 *   The Shopify-installed RudderStack pixel only forwards a fixed set of
 *   standard Shopify Customer Event names. Our custom events (PDP engagement,
 *   cart_viewed, customize_form_submitted, ...) are never forwarded, so we
 *   send them ourselves.
 *
 * Transport — RudderStack HTTP API source (best practice, verified against
 * RudderStack docs 2026-06-29):
 *   POST {dataplane}/v1/track   with HTTP Basic auth (writeKey as username,
 *   empty password). The HTTP source preserves the event name, anonymousId,
 *   and properties EXACTLY as sent — so events land as e.g.
 *   `customize_form_submitted` (not the generic `webhook_source_event` a
 *   Webhook source would wrap them in) and keep our anonymousId so they join
 *   to the Shopify-source events.
 *
 *   HISTORY: this used to POST to /v1/webhook against the Shopify source key
 *   (silently dropped, HTTP 200), then a Webhook source (which wraps every
 *   payload as `webhook_source_event` and discards anonymousId). Both wrong.
 *   The HTTP source below is the correct tool.
 *
 * Credentials (PUBLIC write key — safe to ship in theme JS; permits WRITE
 * only, not READ):
 *   source type:  HTTP API
 *   writeKey:     3Fo1iekPYnJpSs6qtco8pPUQ88m
 *   source_id:    3Fo1ilUckyQ3RQQknOWwC1isqzm
 *   data plane:   autonomousfwaw.dataplane.rudderstack.com
 *
 * Lands in: rudder_cdp.{event_name} (one table per distinct event name),
 * tagged with this source_id; join to Shopify-source events via anonymous_id.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.rudderTrack) return; // idempotent

  var WRITE_KEY = '3Fo1iekPYnJpSs6qtco8pPUQ88m';
  var ENDPOINT = 'https://autonomousfwaw.dataplane.rudderstack.com/v1/track';
  var SOURCE_ID = '3Fo1ilUckyQ3RQQknOWwC1isqzm';

  // Pull the Shopify anonymous-visitor id from the standard `_shopify_y`
  // cookie. This is the same id Shopify Customer Events stamps as `clientId`,
  // so events sent here are joinable to events from the standard pixel path
  // on the same visitor.
  function getAnonymousId() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      if (match) return decodeURIComponent(match[1]);
    } catch (e) {}
    return null;
  }

  function rudderTrack(eventName, properties) {
    if (!eventName) return;
    try {
      var body = {
        type: 'track',
        event: eventName,
        anonymousId: getAnonymousId(),
        properties: properties || {},
        context: {
          source_id: SOURCE_ID,
          library: { name: 'rashmi-theme-http' },
          page: {
            path: window.location.pathname,
            url: window.location.href,
            referrer: document.referrer || '',
            title: document.title
          },
          userAgent: navigator.userAgent
        },
        timestamp: new Date().toISOString()
      };
      // keepalive lets the request finish even if the page is unloading
      // (e.g. the user navigates away right after the event fires).
      fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Basic auth: username = writeKey, password = empty.
          'Authorization': 'Basic ' + btoa(WRITE_KEY + ':')
        },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      }).catch(function () { /* fire-and-forget */ });
    } catch (e) { /* never break the page for analytics */ }
  }

  window.rudderTrack = rudderTrack;
})();
